import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    change(event) {
        const selectElement = event.target
        const selectedLink = selectElement.value
        const form = this.element.closest("form")
        const linkArgInputs = form.querySelectorAll('[name^="page_block[link_args]"]')
        const params = new URLSearchParams()
        params.append("link", selectedLink)
        linkArgInputs.forEach(input => {
            params.append(input.name, input.value)
        })
        if (selectedLink) {
            const url = event.target.dataset.url
            const fullUrl = `${url}?${params.toString()}`
            let token = document.querySelector('meta[name="csrf-token"]').content
            fetch(fullUrl, {
                method: 'GET',
                headers: {
                    "X-CSRF-Token": token,
                    "Accept": "text/vnd.turbo-stream.html"
                }
            })
                .then(response => response.text())
                .then(html => {
                    Turbo.renderStreamMessage(html)
                })
        }
    }
}